/** Text-entry and IME predicates for keyboard handlers that share editable UI. */
const NON_TEXT_INPUT_TYPES = new Set([
  'button',
  'checkbox',
  'file',
  'hidden',
  'image',
  'radio',
  'range',
  'reset',
  'submit'
]);

export function isTextEntryControl(element) {
  if (!element) return false;
  const tag = element.tagName?.toLowerCase();
  if (tag === 'textarea') return true;
  if (tag === 'input') return !NON_TEXT_INPUT_TYPES.has(element.type?.toLowerCase());
  if (element.isContentEditable) return true;
  const editable = element.closest?.('[contenteditable]');
  return (
    !!editable &&
    ['', 'true', 'plaintext-only'].includes(editable.getAttribute('contenteditable')?.toLowerCase())
  );
}

export function isComposing(event) {
  return !!event?.isComposing || event?.keyCode === 229;
}
